import withMetadataArgument from './withMetadataArgument.js'
import { getExampleNumber as _getExampleNumber } from '../../core/index.js'

export function getExampleNumber() {
	return withMetadataArgument(_getExampleNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getExampleNumber.js
// module id = 1626
// module chunks = 0